import { hideParentLayout } from "src/common/utils";
import { PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";

const HideLayout = (props: PropsWithChildren) => {
  const location = useLocation().pathname;
  let hideLayout = hideParentLayout(location, [
    "/settings/management/roles/create",
    "/settings/management/roles/edit",
    "/settings/management/users/create",
    "/settings/management/users/edit",
    "/settings/policies/create",
    "/settings/policies/edit",
    "/programmes/detail/add-member",
    "/programmes/detail/change-status",
  ]);

  return <>{hideLayout ? null : props.children}</>;
};

export default HideLayout;
